import { SECTION_TYPES } from "@/lib/constants/sections";
import { SquareSplitHorizontal } from "lucide-react";

const beforeAndAfterSection = {
  type: SECTION_TYPES.BEFORE_AND_AFTER,
  content: {
    header: "",
    images: [
      {
        before: {
          imageUrl:
            "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=60&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3",
          altText: "Old brick home needing renovation",
        },
        after: {
          imageUrl:
            "https://images.unsplash.com/photo-1434082033009-b81d41d32e1c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          altText: "Beautifully renovated modern home",
        },
      },
      {
        before: {
          imageUrl:
            "https://images.unsplash.com/photo-1472224371017-08207f84aaae?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          altText: "Outdated home exterior",
        },
        after: {
          imageUrl:
            "https://images.unsplash.com/photo-1449844908441-8829872d2607?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          altText: "Stunning modern exterior transformation",
        },
      },
    ],
  },
  meta: {
    displayName: "Before and After",
    displayDescription: "Showcase your transformation projects with before and after photos.",
    displayIcon: SquareSplitHorizontal,
    variantsCount: 2,
  },
};

export default beforeAndAfterSection;
